import { css } from '@emotion/core'

export const styles = {
  container: css`
    width: 100%;
    padding: 15px;

    margin-bottom: 15px;
    border-radius: 3px;

    background: white;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.02), 0 10px 7px rgba(0, 0, 0, 0.01);

    display: flex;
    flex-direction: column;

    cursor: pointer;
    transition: 300ms;
    &:hover {
      transition: 150ms;
      transform: scale(1.002) translateY(-1px);
      box-shadow: 0 2px 16px rgba(0, 0, 0, 0.05), 0 0 1px rgba(0, 0, 0, 0.03);
    }

    border-left: 3px solid white;
    border-right: 3px solid white;
  `,

  accent: css`
    border-left: 3px solid rgba(58, 137, 196, 0.85);
    border-right: 3px solid rgba(58, 137, 196, 0.85);
  `,

  acceptedAccent: css`
    border-left: 3px solid rgba(16, 172, 132, 0.85);
    border-right: 3px solid rgba(16, 172, 132, 0.85);
  `,

  section: css`
    margin: 8px 0;

    &:first-child {
      margin-top: 0;
    }

    &:last-child {
      margin-bottom: 0;
    }

    display: flex;
    flex-direction: row;
    justify-content: space-between;
  `,

  side: css`
    font-size: 13px;
    text-transform: capitalize;

    display: flex;
    align-items: center;
  `,

  items: {
    name: css`
      font-size: 15px;
      font-weight: 600;
      color: rgb(90, 90, 90);
    `,

    created: css`
      font-size: 12px;
    `,

    car: css``,

    offers: css`
      font-size: 12px;
      text-transform: none;
    `,

    accent: css`
      color: rgb(58, 137, 196);
      font-weight: 600;
    `,

    acceptedAccent: css`
      color: rgb(16, 172, 132);
    `,
  },
}
